import { render, staticRenderFns } from "./SidebarSortBy.vue?vue&type=template&id=092d7732"
import script from "./SidebarSortBy.vue?vue&type=script&lang=js"
export * from "./SidebarSortBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports